export const SOCKET_API_PATH = '/api/ws' as const

export const SOCKET_AUTHENTICATION_ERROR_MESSAGES = {
  invalidToken: 'Invalid Token',
  unauthenticated: 'Unauthenticated',
} as const

export type SocketAuthenticationErrorMessage =
  (typeof SOCKET_AUTHENTICATION_ERROR_MESSAGES)[keyof typeof SOCKET_AUTHENTICATION_ERROR_MESSAGES]
